import { Link } from "react-router-dom";
import { Lock, Sparkles, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";

// Full-page upgrade prompt shown when a teacher lacks a Pro/Program plan.
export function UpgradePrompt({ feature }) {
  const { lang } = useLang();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-lg mx-auto px-4 py-20 text-center space-y-6" data-testid="upgrade-prompt">
        <span className="mx-auto h-16 w-16 rounded-2xl bg-secondary/15 flex items-center justify-center">
          <Lock className="h-8 w-8 text-secondary" />
        </span>
        <div className="space-y-2">
          <h1 className="font-heading font-extrabold text-3xl tracking-tight">
            {lang === "es" ? "Función de Teacher Pro" : "A Teacher Pro feature"}
          </h1>
          <p className="text-muted-foreground text-lg">
            {lang === "es"
              ? `${feature || "Esta función"} está incluida en Teacher Pro. Actualiza para desbloquear el planificador semanal, Pregúntale a Brilla y más.`
              : `${feature || "This feature"} is included with Teacher Pro. Upgrade to unlock the Weekly Planner, Ask Brilla, and more.`}
          </p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5 text-left space-y-2">
          {[
            lang === "es" ? "Planificador semanal bilingüe" : "Weekly bilingual planner",
            lang === "es" ? "Entrenador Pregúntale a Brilla" : "Ask Brilla AI coach",
            lang === "es" ? "Hacer Mi Actividad Bilingüe" : "Make My Activity Bilingual",
          ].map((f, i) => (
            <div key={i} className="flex items-center gap-2 text-sm"><Sparkles className="h-4 w-4 text-primary" /> {f}</div>
          ))}
        </div>
        <Link to="/pricing">
          <Button className="rounded-full bg-secondary hover:bg-secondary/90 h-12 px-7 text-base" data-testid="upgrade-cta">
            {lang === "es" ? "Ver planes" : "See plans"} <ArrowRight className="h-5 w-5" />
          </Button>
        </Link>
      </main>
    </div>
  );
}
